
<template>
  <div>
    <v-layout align-center ma-3 row>
      <div v-if="coverImageUrl" class="cover mr-2">
        <placeholder-image :url="coverImageUrl" />
      </div>
      <v-icon v-else class="ps-2 pe-2">apps</v-icon>
      <v-layout column>
        <span class="category-name">{{ category.category.name }}</span>
        <span class="category-description">{{ category.category.shortDescription }}</span>
      </v-layout>
      <amount-badge :amount="amountInCart" />
      <v-icon color="grey darken-2" class="ml-2">mdi-chevron-right</v-icon>
    </v-layout>
    <v-divider />
  </div>
</template>

<script>
import { mapState } from 'vuex'
export default {
  props: {
    category: Object,
  },
  computed: {
    ...mapState({
      state: (state) => state.state,
      cartProducts: (state) => state.cart.cartProducts,
    }),
    amountInCart () {
      var amount = 0
      this.cartProducts
        .filter((cp) => {
          return cp.product.categoryId === this.category.category.id
        })
        .forEach((item) => {
          amount += item.quantity
        })
      return amount
    },
    coverImageUrl () {
      return this.category.category.coverImageUrl
    },
  },
  components: {
    PlaceholderImage: () => import('@/components/app-components/PlaceholderImage.vue'),
    AmountBadge: () => import('@/components/view-components/catalog/AmountBadge.vue'),
  },
}
</script>

<style lang="scss">
.category-name {
  font-weight: 500;
  color: grey;
  font-size: 18px;
}
.category-description {
  color: grey;
  font-size: 16px;
}
.v-btn__content {
  font-size: 13px !important;
}
.cover {
  min-width: 60px;
  width: 60px;
  height: 60px;
  border-radius: 8px;
  overflow: hidden;
  display: flex;
  justify-content: center;
}
</style>

<style lang="scss" scoped>
.layout:first-of-type {
  flex-wrap: nowrap;
}
</style>
